import { IXC_RAGL_V1_TRANSACTION_STATE_ENTITY_NAME } from '@interxfi/api-client/generated/entities/ixc-ragl-v1-transaction-state';
import { Pill, type PillProps } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import type { IxcRaglV1TransactionStatus } from '@interxfi/types/generated/api';
import { getEntityVariant } from '../../../util/entity-status-variants';

interface RaglTransactionStatusPillProps extends Omit<PillProps, 'children' | 'variant'> {
  status: IxcRaglV1TransactionStatus | undefined;
}

export function RaglTransactionStatusPill({ isPending, status, ...props }: RaglTransactionStatusPillProps) {
  return (
    <Pill isPending={!status || isPending} {...props} variant={getEntityVariant(IXC_RAGL_V1_TRANSACTION_STATE_ENTITY_NAME, status)}>
      <TranslatedText defaultValue={status} i18nKey={{ namespace: 'ixcRaglV1', enumName: 'IxcRaglV1TransactionStatus', value: status }} />
    </Pill>
  );
}
